import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_INPUT_GENERICO, ESTILO_BOTON_GENERAL_CANCELAR } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import Spinner from "../../../components/spinner";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { actualizarProgramacionCamiones, crearProgramacionCamiones, obtenerProgramacionCamiones } from "../../../api/api-programacion-camiones";
import { useToast, useProcessing } from "../../../context/ui-feedback-context";
import SendRequestComponent from "../../../components/send_request_component";
import Select from "react-select";
import { obtenerListaFormularioViaje } from "../../../api/api-formulario-viaje";
import Calendar from "../../../components/calendar";
import TimeComponent from "../../../components/time-component";
import { FORMULARIO_VIAJE_KEY } from "../../../utils/const/formulario-const";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";
import cargandoCard from "../../../components/cargando-card";
import { obtenerListaTransportadora } from "../../../api/api-transportadora";
import { obtenerTodasLasUnidades } from "../../../api/gestion-dts/gestion";
import { obtenerGeocercasPorIdGrupoGeocerca, obtenerListaGrupoGeocerca } from "../../../api/api-grupo-geocerca";
import { useConceptoGeocerca } from "../../../page/administracion/gestionar-grupo-geocerca/concepto-geocerca";
import { obtenerListaProducto } from "../../../api/api-producto";
import { obtenerListaTipoCarguio } from "../../../api/api-tipo-carguio";
import { obtenerUsuarioMovilTipoChofer, obtenerInfoConductorConNumeroPlaca } from "../../../api/api-usuario-movil";
import { FileDown } from "lucide-react";
import { sharedExportarPdf } from "../../../utils/shared-functions";

const FORM_BG = "#e8f1f8";
const FORM_BORDER = "#dadce0";
const FORM_TEXT = "#0F3457";
const FORM_TEXT_MUTED = "#5f6368";
const FORM_REQUIRED = "#d93025";

export default function ProgramacionCamionesPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");

  const [listaFormularioViaje, setListaFormularioViaje] = useState([]);
  const [formularioViajeSelected, setFormularioViajeSelected] = useState(null);

  const [listaTransportadoras, setListaTransportadoras] = useState([]);
  const [listaVehiculos, setListaVehiculos] = useState([]);
  const [listaGeocercaOrigenes, setListaGeocercaOrigenes] = useState([]);
  const [listaGeocercaDestinos, setListaGeocercaDestinos] = useState([]);
  const [listaGeocercaGeoruta, setListaGeocercaGeoruta] = useState([]);
  const [listaProductos, setListaProductos] = useState([]);
  const [listaTiposCarga, setListaTiposCarga] = useState([]);
  const [listaChoferes, setListaChoferes] = useState([]);

  const [sendRequest, setSendRequest] = useState(false);

  // Toast only (success / error messages)
  const { showToast } = useToast();
  // Processing overlay only (loading while API runs)
  const { showProcessing, hideProcessing } = useProcessing();

  const [step, setStep] = useState(1);

  const [dynamicFields, setDynamicFields] = useState(null);

  const pdfContentRef = useRef(null);

  const conceptoGeocerca = useConceptoGeocerca();

  const [btnExportar, setBtnExportar] = useState(false);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setBtnExportar(data.params.btnExportar);
        setTitulo(data.titulo);
        // Initialize dynamic fields if they exist
      }

      const [
        responseFormularioViaje,
        responseTransportadora,
        unidades,
        responseGrupoGeocerca,
        responseProducto,
        responseTipoCarga,
        responseUsuarioMovilTipoChofer,
      ] = await Promise.all([
        obtenerListaFormularioViaje({ habilitado: 1 }, true, t),
        obtenerListaTransportadora({ habilitado: 1 }, true, t),
        obtenerTodasLasUnidades(),
        obtenerListaGrupoGeocerca({ habilitado: 1 }, true, t),
        obtenerListaProducto({ habilitado: 1 }, true, t),
        obtenerListaTipoCarguio({ habilitado: 1 }, true, t),
        obtenerUsuarioMovilTipoChofer(true),
      ]);

      // const responseFormularioViaje = await obtenerListaFormularioViaje({ habilitado: 1 }, true, t);
      // console.log("responseFormularioViaje");
      // console.log(responseFormularioViaje);
      if (Array.isArray(responseFormularioViaje)) {
        setListaFormularioViaje(responseFormularioViaje);
        if (data.params.idFormularioViaje !== undefined && data.params.idFormularioViaje !== null) {
          const formularioViaje = responseFormularioViaje.find((item) => item.value === data.params.idFormularioViaje);
          // console.log("formularioViaje");
          // console.log(formularioViaje);
          if (formularioViaje !== undefined && formularioViaje !== null) {
            setFormularioViajeSelected(formularioViaje);
            setStep(2);
            let respuestas = data.params.respuestas;
            if (respuestas !== undefined && respuestas !== null) {
              respuestas = JSON.parse(respuestas);
              if (Array.isArray(respuestas)) {
                setDynamicFields(respuestas);
              }
            }
          }
        }
      }

      // const responseTransportadora = await obtenerListaTransportadora({ habilitado: 1 }, true, t);
      // console.log("responseTransportadora");
      // console.log(responseTransportadora);
      if (Array.isArray(responseTransportadora)) {
        setListaTransportadoras(responseTransportadora);
      }

      // const unidades = await obtenerTodasLasUnidades();
      setListaVehiculos(unidades);
      // if (data.params.valuePlaca !== undefined && data.params.valuePlaca !== null) {
      //   const unidad = unidades.find((item) => item.value === data.params.valuePlaca);
      //   setUnidadSelected(unidad);
      // }
      const idGrupoOrigen = Array.isArray(responseGrupoGeocerca)
        ? responseGrupoGeocerca.find((item) => item.idConceptoGeocerca === 10)?.idGrupoGeocerca
        : null;
      const idGrupoDestino = Array.isArray(responseGrupoGeocerca)
        ? responseGrupoGeocerca.find((item) => item.idConceptoGeocerca === 2)?.idGrupoGeocerca
        : null;
      const [geocercasOrigen, geocercasDestino] = await Promise.all([
        obtenerGeocercasPorIdGrupoGeocerca({ habilitado: 1, idGrupoGeoCerca: idGrupoOrigen }),
        obtenerGeocercasPorIdGrupoGeocerca({ habilitado: 1, idGrupoGeoCerca: idGrupoDestino }),
      ]);
      if (geocercasOrigen.error === false && Array.isArray(geocercasOrigen.body)) {
        setListaGeocercaOrigenes(geocercasOrigen.body);
      }
      if (geocercasDestino.error === false && Array.isArray(geocercasDestino.body)) {
        setListaGeocercaDestinos(geocercasDestino.body);
      }
      const responseGeocercaGeoruta = await obtenerGeocercasPorIdGrupoGeocerca({ idGrupoGeoCerca: responseGrupoGeocerca.find((item) => item.idConceptoGeocerca === 4)?.idGrupoGeocerca });
      if (responseGeocercaGeoruta.error === false && Array.isArray(responseGeocercaGeoruta.body) && responseGeocercaGeoruta.body.length > 0) {
        setListaGeocercaGeoruta(responseGeocercaGeoruta.body);
      }

      // const responseProducto = await obtenerListaProducto({ habilitado: 1 }, true, t);
      // console.log('responseProducto');
      // console.log(responseProducto);
      if (Array.isArray(responseProducto)) {
        setListaProductos(responseProducto);
      }

      // const responseTipoCarga = await obtenerListaTipoCarguio({ habilitado: 1 }, true, t);
      // console.log('responseTipoCarga');
      // console.log(responseTipoCarga);
      if (Array.isArray(responseTipoCarga)) {
        setListaTiposCarga(responseTipoCarga);
      }

      if (Array.isArray(responseUsuarioMovilTipoChofer)) {
        setListaChoferes(responseUsuarioMovilTipoChofer);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  };

  // const charLimits = {
  //   codigo: 64,
  //   descripcion: 128,
  //   nota: 512,
  // };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   let next = value;
  //   if (next.length <= charLimits[name]) {
  //     setFormData({
  //       ...formData,
  //       [name]: next,
  //     });
  //   }
  // };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarStep1 = () => {
    try {
      let message = "";
      if (formularioViajeSelected === null) {
        message = message + t("alert_debe_seleccionar_formulario_viaje") + '\n';
      }

      if (message.length > 0) {
        showToast(message.trim(), "warning", 4000);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarStep1 err');
      console.log(err);
      return false;
    }
  };

  const validarStep2 = () => {
    try {
      let message = "";
      if (formularioViajeSelected === null) {
        message = message + t("alert_debe_seleccionar_formulario_viaje") + '\n';
      }

      if (message.length > 0) {
        showToast(message.trim(), "warning", 4000);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarStep1 err');
      console.log(err);
      return false;
    }
  };

  const handleStep1Click = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarStep1();
    if (valido === false) {
      return;
    }
    console.log("formularioViajeSelected");
    console.log(formularioViajeSelected);
    const fields = (JSON.parse(formularioViajeSelected.dynamicFields));
    console.log("fields");
    console.log(fields);
    if (Array.isArray(fields)) {
      fields.sort((a, b) => a.order - b.order);
      setDynamicFields(fields);
      setStep(2);
    }
    if (Array.isArray(fields) === false) {
      showToast(t("alert_no_se_pudo_obtener_campos_dinamicos"), "warning", 4000);
      return;
    }
  };

  /** Updates `value` on the matching field inside dynamicFields. */
  const handleDynamicFieldChange = (fieldId, value) => {
    setDynamicFields((prev) => {
      if (!Array.isArray(prev)) return prev;
      return prev.map((field) =>
        field.id === fieldId ? { ...field, value } : field
      );
    });
  };

  /** Selected vehicle from dynamic fields (react-select option). */
  const vehiculoSelectedValue = Array.isArray(dynamicFields)
    ? dynamicFields.find((f) => f.type === FORMULARIO_VIAJE_KEY.SELECCIONE_VEHICULO)?.value
    : null;

  useEffect(() => {
    const syncChoferFromVehiculo = async () => {
      if (!Array.isArray(dynamicFields)) return;

      const choferField = dynamicFields.find(
        (f) => f.type === FORMULARIO_VIAJE_KEY.SELECCIONE_CHOFER && f.enabled
      );
      if (!choferField) return;

      const valuePlaca = vehiculoSelectedValue?.value ?? null;
      if (valuePlaca == null || String(valuePlaca).trim() === "") {
        if (choferField.value) {
          handleDynamicFieldChange(choferField.id, "");
        }
        return;
      }

      try {
        const response = await obtenerInfoConductorConNumeroPlaca({ valuePlaca });
        // console.log("obtenerInfoConductorConNumeroPlaca", response);
        if (response.error === false && response.data !== null && response.data !== undefined) {
          const conductor = response.data;
          const choferOption =
            listaChoferes.find((c) => c.value === conductor.id) ?? {
              value: conductor.id,
              label: conductor.nombreConductor ?? conductor.label ?? String(conductor.id),
            };
          handleDynamicFieldChange(choferField.id, choferOption);
        }
        if (response.error === false && (response.data === null || response.data === undefined)) {
          handleDynamicFieldChange(choferField.id, null);
        }

      } catch (err) {
        console.log("syncChoferFromVehiculo err");
        console.log(err);
      }
    };

    syncChoferFromVehiculo();
    // Only react to vehicle selection changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehiculoSelectedValue?.value]);

  const getFieldDisplayValue = (field) => {
    const value = field?.value;
    if (value == null || value === "") {
      return "—";
    }
    if (typeof value === "object") {
      return value.label ?? String(value.value ?? "—");
    }
    return String(value);
  };

  const wrapGoogleFormField = (field, control) => (
    <div
      key={field.id}
      className="group rounded-lg border bg-white shadow-sm transition-all focus-within:shadow-md"
      style={{
        borderColor: FORM_BORDER,
        ["--form-accent"]: COLOR_AZUL_MAIN,
      }}
    >
      <div
        className="h-1.5 rounded-t-lg opacity-0 transition-opacity group-focus-within:opacity-100"
        style={{ backgroundColor: COLOR_AZUL_MAIN }}
      />
      <div className="px-4 py-5 sm:px-6 sm:py-6">
        <label
          htmlFor={field.key}
          className="mb-4 block text-[16px] leading-6"
          style={{ color: FORM_TEXT }}
        >
          {field.label}
          {field.obligatorio ? (
            <span className="ml-1" style={{ color: FORM_REQUIRED }} aria-hidden="true">*</span>
          ) : null}
        </label>
        <div className="w-full max-w-full sm:max-w-md">{control}</div>
      </div>
    </div>
  );

  const wrapPdfReportField = (field) => (
    <div
      key={`pdf-${field.id}`}
      data-pdf-block
      className="overflow-hidden rounded-lg border bg-white px-5 py-4 sm:px-6 sm:py-5"
      style={{ borderColor: FORM_BORDER }}
    >
      <p
        className="m-0 mb-2 text-sm font-semibold leading-5"
        style={{ color: FORM_TEXT_MUTED }}
      >
        {field.label}
        {field.obligatorio ? (
          <span className="ml-1" style={{ color: FORM_REQUIRED }}>*</span>
        ) : null}
      </p>
      <p
        className="m-0 text-base leading-7 break-words whitespace-pre-wrap"
        style={{ color: FORM_TEXT, minHeight: "1.75rem" }}
      >
        {getFieldDisplayValue(field)}
      </p>
    </div>
  );

  const renderPdfReportField = (field) => {
    if (!field?.enabled) return null;
    return wrapPdfReportField(field);
  };

  const googleFormInputClass =
    "w-full bg-transparent border-0 border-b border-gray-300 rounded-none px-0 py-2 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-0 focus:border-[color:var(--form-accent)] transition-colors";

  const googleFormSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 44,
      border: "none",
      borderBottom: state.isFocused ? `2px solid ${COLOR_AZUL_MAIN}` : `1px solid ${FORM_BORDER}`,
      borderRadius: 0,
      boxShadow: "none",
      backgroundColor: "transparent",
      "&:hover": {
        borderBottom: state.isFocused ? `2px solid ${COLOR_AZUL_MAIN}` : `1px solid ${FORM_TEXT_MUTED}`,
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "4px 0",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9aa0a6",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const renderSelectField = (field, options, placeholder) =>
    wrapGoogleFormField(
      field,
      <Select
        inputId={field.key}
        options={options}
        value={field.value || null}
        onChange={(option) => handleDynamicFieldChange(field.id, option)}
        placeholder={placeholder}
        isClearable={true}
        isSearchable={true}
        styles={googleFormSelectStyles}
        classNamePrefix="google-form-select"
        className="text-black"
        menuPortalTarget={document.body}
      />
    );

  const renderDynamicField = (field) => {
    if (!field?.enabled) return null;

    switch (field.type) {
      case FORMULARIO_VIAJE_KEY.NOTA:
        return wrapGoogleFormField(
          field,
          <textarea
            id={field.key}
            name={field.key}
            value={field.value ?? ""}
            onChange={(e) => handleDynamicFieldChange(field.id, e.target.value)}
            className={`${googleFormInputClass} resize-y min-h-[96px]`}
            placeholder={t("placeholder_ingresa_nota")}
            rows={3}
            required={field.obligatorio}
          />
        );

      case FORMULARIO_VIAJE_KEY.FECHA:
        return wrapGoogleFormField(
          field,
          <Calendar
            id={field.key}
            name={field.key}
            value={field.value ?? ""}
            onChange={(date) => handleDynamicFieldChange(field.id, date)}
            placeholder={t("placeholder_seleccione_fecha")}
            required={field.obligatorio}
          />
        );

      case FORMULARIO_VIAJE_KEY.HORA:
        return wrapGoogleFormField(
          field,
          <TimeComponent
            id={field.key}
            name={field.key}
            value={field.value ?? ""}
            onChange={(time) => handleDynamicFieldChange(field.id, time)}
            placeholder={t("placeholder_seleccione_hora")}
            required={field.obligatorio}
          />
        );

      case FORMULARIO_VIAJE_KEY.SELECCIONE_TRANSPORTADORA:
        return renderSelectField(
          field,
          listaTransportadoras,
          t("placeholder_seleccione_transportadora")
        );

      case FORMULARIO_VIAJE_KEY.SELECCIONE_VEHICULO:
        return renderSelectField(
          field,
          listaVehiculos,
          t("placeholder_seleccione_vehiculo")
        );

      case FORMULARIO_VIAJE_KEY.SELECCIONE_ORIGEN:
        return renderSelectField(
          field,
          listaGeocercaOrigenes,
          t("placeholder_seleccione_geocerca_origen")
        );

      case FORMULARIO_VIAJE_KEY.SELECCIONE_DESTINO:
        return renderSelectField(
          field,
          listaGeocercaDestinos,
          t("placeholder_seleccione_geocerca_destino")
        );
      case FORMULARIO_VIAJE_KEY.SELECCIONE_GEORUTA:
        return renderSelectField(
          field,
          listaGeocercaGeoruta,
          t("placeholder_seleccione_geocerca_georuta")
        );

      case FORMULARIO_VIAJE_KEY.SELECCIONE_PRODUCTO:
        return renderSelectField(
          field,
          listaProductos,
          t("placeholder_seleccione_producto")
        );

      case FORMULARIO_VIAJE_KEY.SELECCIONE_TIPO_DE_CARGA:
        return renderSelectField(
          field,
          listaTiposCarga,
          t("placeholder_seleccione_tipo_de_carga")
        );

      case FORMULARIO_VIAJE_KEY.SELECCIONE_CHOFER:
        return renderSelectField(
          field,
          listaChoferes,
          t("placeholder_seleccione_chofer")
        );

      case FORMULARIO_VIAJE_KEY.INPUT_CANTIDAD:
        return wrapGoogleFormField(
          field,
          <input
            id={field.key}
            name={field.key}
            type="number"
            value={field.value ?? ""}
            onChange={(e) => handleDynamicFieldChange(field.id, e.target.value)}
            className={googleFormInputClass}
            placeholder={field.label}
            required={field.obligatorio}
            min={0}
          />
        );

      default:
        return wrapGoogleFormField(
          field,
          <input
            id={field.key}
            name={field.key}
            type="text"
            value={field.value ?? ""}
            onChange={(e) => handleDynamicFieldChange(field.id, e.target.value)}
            className={googleFormInputClass}
            placeholder={field.label}
            required={field.obligatorio}
          />
        );
    }
  };

  const getPdfFileName = () => {
    const nombre = formularioViajeSelected?.label ?? formularioViajeSelected?.descripcion ?? "";
    if (String(nombre).trim().length === 0) {
      return "programacion-camiones";
    }
    return String(nombre).trim().replace(/[^\w.-]+/g, "-");
  };

  const handleExportarPdf = async () => {
    if (!Array.isArray(dynamicFields) || dynamicFields.length === 0) {
      showToast(t("label_sin_datos"), "warning", 4000);
      return;
    }
    try {
      await sharedExportarPdf(pdfContentRef, getPdfFileName(), {
        onStart: showProcessing,
        onFinish: hideProcessing,
        onError: () => {
          showToast(t("label_sin_datos"), "error", 4000);
        },
      });
    } catch (err) {
      console.log("handleExportarPdf err");
      console.log(err);
      hideProcessing();
      showToast(t("label_sin_datos"), "error", 4000);
    }
  };

  const handleGuardarResponse = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarStep2();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.idFormularioViaje = formularioViajeSelected.value;
    objEnviar.respuestas = dynamicFields;
    // console.log('objEnviar');
    // console.log(objEnviar);
    // return;
    setSendRequest(true);
    showProcessing();
    try {
      if (formData.id === 0) {
        // console.log('crear correo');
        const response = await crearProgramacionCamiones(objEnviar);
        hideProcessing();
        // console.log('creado');
        // console.log(creado);
        if (response.error === false) {
          showToast(t("alert_se_creo_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_crear"));
        }
      }
      if (formData.id !== 0) {
        // console.log('actualizar correo');
        const response = await actualizarProgramacionCamiones(objEnviar);
        hideProcessing();
        // console.log('modificado');
        // console.log(modificado);
        if (response.error === false) {
          showToast(t("alert_se_modifico_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_modificar"));
        }
      }
    } catch (err) {
      console.log('handleSaveClick err');
      console.log(err);
    } finally {
      hideProcessing();
      setSendRequest(false);
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div
          className="min-h-screen px-3 py-4 sm:px-4 sm:py-6 md:px-6"
          style={{ backgroundColor: FORM_BG }}
        >
          <div className="mx-auto w-full max-w-[640px] md:max-w-[720px]">
            {/* Header card */}
            <div
              className="mb-3 overflow-hidden rounded-lg border bg-white shadow-sm"
              style={{ borderColor: FORM_BORDER }}
            >
              <div className="h-2.5" style={{ backgroundColor: COLOR_AZUL_MAIN }} />
              <div className="relative flex items-center px-4 py-5 sm:px-6 sm:py-6">
                <div className="absolute left-4 top-1/2 -translate-y-1/2 sm:left-6">
                  <ArrowBack onClick={handleCancelClick} />
                </div>
                <div className="min-w-0 w-full text-center px-10">
                  <h2
                    className="text-[22px] sm:text-[28px] font-normal leading-tight"
                    style={{ color: FORM_TEXT }}
                  >
                    {titulo}
                  </h2>
                  {step === 2 && formularioViajeSelected?.label ? (
                    <p className="mt-2 text-sm" style={{ color: FORM_TEXT_MUTED }}>
                      {formularioViajeSelected.label}
                    </p>
                  ) : null}
                </div>
              </div>
            </div>

            {step === 1 && (
              <>
                <div
                  className="mb-3 overflow-hidden rounded-lg border bg-white shadow-sm"
                  style={{ borderColor: FORM_BORDER }}
                >
                  <div className="px-4 py-5 sm:px-6 sm:py-6">
                    <label
                      className="mb-4 block text-[16px] leading-6"
                      style={{ color: FORM_TEXT }}
                    >
                      {t("label_formulario_viaje")}
                      <span className="ml-1" style={{ color: FORM_REQUIRED }}>*</span>
                    </label>
                    <div className="w-full max-w-full sm:max-w-md">
                      <Select
                        options={listaFormularioViaje}
                        value={formularioViajeSelected}
                        onChange={(option) => setFormularioViajeSelected(option)}
                        placeholder={t("placeholder_seleccione_formulario_viaje")}
                        isClearable={true}
                        isSearchable={true}
                        styles={googleFormSelectStyles}
                        classNamePrefix="google-form-select"
                        className="text-black"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between gap-3 px-1 pt-2">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    {t("label_cancelar")}
                  </button>
                  <SendRequestComponent
                    loading={sendRequest}
                    onClick={handleStep1Click}
                    label={t("label_siguiente")}
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                    type="button"
                  />
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <div className="flex flex-col gap-3">
                  {Array.isArray(dynamicFields) &&
                    dynamicFields.map((field) => renderDynamicField(field))}
                </div>

                {/* Off-screen report layout for PDF export (plain text, no react-select) */}
                <div
                  ref={pdfContentRef}
                  className="absolute left-[-9999px] top-0 w-[720px] flex flex-col gap-3 bg-white text-black pointer-events-none"
                  style={{ fontFamily: "sans-serif" }}
                  aria-hidden="true"
                >
                  <div
                    data-pdf-block
                    className="overflow-hidden rounded-lg border bg-white px-5 py-5 sm:px-6 sm:py-6"
                    style={{ borderColor: FORM_BORDER }}
                  >
                    <div
                      className="mb-3 h-1 rounded"
                      style={{ backgroundColor: COLOR_AZUL_MAIN }}
                    />
                    <h2
                      className="m-0 text-center text-2xl font-semibold leading-tight"
                      style={{ color: FORM_TEXT }}
                    >
                      {formularioViajeSelected?.label ?? titulo}
                    </h2>
                  </div>
                  {Array.isArray(dynamicFields) &&
                    dynamicFields.map((field) => renderPdfReportField(field))}
                </div>

                <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between px-1">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={() => setStep(1)}
                  >
                    {t("label_atras")}
                  </button>
                  <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
                    {formData.id !== 0 && btnExportar === true && (
                      <button
                        type="button"
                        onClick={handleExportarPdf}
                        className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white transition-colors"
                        style={{ backgroundColor: COLOR_AZUL_MAIN }}
                      >
                        <FileDown className="h-4 w-4" />
                        {t("label_exportar_pdf")}
                      </button>
                    )}
                    <SendRequestComponent
                      loading={sendRequest}
                      onClick={handleGuardarResponse}
                      label={t("label_aceptar")}
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      type="button"
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
